import ApplicationSerializer from 'lumen/serializers/application';

export default class SmartInsightsPropertyTagsSerializer extends ApplicationSerializer {
  attrs = {
    subscription: 'subscription_id',
    regionalDos: 'regional_dos_id',
    regionalVp: 'regional_vp_id',
    dorm: 'dorm_id',
  };

  primaryKey = 'subscription';
}
